export default __webpack_public_path__ + "static/media/PridedickMan.47fc2872.png";